module.exports = __webpack_public_path__ + "static/media/banner-img.86b48d7c.jpg";